import { computed, inject, Injectable } from '@angular/core';

import { EditEntityDetailService } from '@connect-services/client/services/edit-entity-detail.service';
import { EditModeLeaveModalService } from '@connect-services/client/services/edit-mode-leave-modal.service';
import { MapEditModeService } from '@connect-services/client/services/map-edit-mode.service';

@Injectable({
    providedIn: 'root',
})
export class EntityEditPanelGuardService {
    public readonly hasPendingEntityEdition = computed<boolean>(() => {
        if (!this.editEntityDetailService.isEditMode()) {
            return false;
        }

        const entityId = this.editEntityDetailService.entityId();
        const layerId = this.editEntityDetailService.layer()?.id;

        if (!entityId || !layerId) {
            return false;
        }

        return this.editEntityDetailService.hasDirtyAttributes() || this.hasActiveGeometryEdition(entityId, layerId);
    });

    private readonly editEntityDetailService = inject(EditEntityDetailService);
    private readonly editModeLeaveModalService = inject(EditModeLeaveModalService);
    private readonly mapEditModeService = inject(MapEditModeService);

    public confirmPanelLeaveIfNeeded(): Promise<boolean> {
        if (!this.hasPendingEntityEdition()) {
            return Promise.resolve(true);
        }

        return this.editModeLeaveModalService.openLeaveEntityEditionDialog();
    }

    private hasActiveGeometryEdition(entityId: string, layerId: string): boolean {
        return (
            this.mapEditModeService.isGeographicEditModeActive() &&
            this.mapEditModeService.editEntityId() === entityId &&
            this.mapEditModeService.activeEditLayerIds().has(layerId)
        );
    }
}
